export default __webpack_public_path__ + "static/media/Mark-4-HUD-Label (Point).e3bdb267.jpg";